export const focusedViewFilterText = "ZLdhq";
export default {focusedViewFilterText};